// reload .....
const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_BASE_URL_INTERNAL: process.env.REACT_APP_API_BASE_URL_INTERNAL,
  IMAGES_BASE_URL: process.env.REACT_APP_IMAGES_BASE_URL,
  SAGA_BUFFER_SIZE: process.env.REACT_APP_SAGA_BUFFER_SIZE
};

export default config;
